<template>
  <AwlTable :heading="tableHeadings" :rows="tableRows" striped>
    <template #column-key-importo="{ value }">
      {{ value | money }}
    </template>
    <template #column-key-delta="{ value }">
      {{ value }}%
    </template>
    <template #column-key-vat="{ value }">
      {{ value }}%
    </template>
    <template #column-key-dilazione="{ value }">
      {{ value * 30 }}
    </template>

    <template v-if="editEnabled" #actions-content="{ row }">
      <ActionEdit class="mr-0 mr-md-2" :to="{ name: 'operative-company.data-analysis.proceeds.edit', params: { proceedId: row.id } }" />
      <ActionDelete @click="remove(row.id)" />
    </template>
  </AwlTable>
</template>

<script>

import formatMoneyFilter from '@/filters/formatMoney';

export default {
  components: {
    AwlTable: () => import('@/libs/Table/components/AwlTable'),
    ActionDelete: () => import('../../Actions/ActionDelete'),
    ActionEdit: () => import('../../Actions/ActionEdit'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    proceeds: {
      type: Array,
      default: () => [],
    },
    editEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableHeadings () {
      return [
        { key: 'name', label: 'Nome' },
        { key: 'importo', label: 'Importo annuo' },
        { key: 'begin', label: 'Primo ricavo' },
        { key: 'end', label: 'Ultimo ricavo' },
        { key: 'frequenzaName', label: 'Frequenza' },
        { key: 'delta', label: 'Delta' },
        { key: 'dilazione', label: 'GG Dilazione' },
        { key: 'vat', label: 'Iva' },
      ];
    },
    tableRows () {
      return (this.proceeds || []).map(r => {
        return r;
      });
    },
  },
  methods: {
    remove (id) {
      if (!this.editEnabled) {
        return;
      }

      this.$emit('delete', id);
    },
  },
};

</script>
